import React, { Component } from 'react';

import Toast from '../../components/Toast';
import Button from '../../components/Button';
import { STATUSES, STATUS_MESSAGES } from '../../common/constants';
import moment from 'moment';
import { useBranding } from '../../branding/BrandingContextProvider';

const ServiceRequestToast = ({
  serviceRequest,
  handleStatusChange
}) => {
  const {branding} = useBranding();
    let statuses = STATUSES;
    let activeStatus = serviceRequest.status && serviceRequest.status.name ? serviceRequest.status.name : '';
    let statusMessage = STATUS_MESSAGES(branding).filter(sm => sm.status === activeStatus)[0]?.message;
    if(statusMessage) {
      if(activeStatus === 'En Route' || activeStatus === 'In Progress') {
        statusMessage = statusMessage + `${serviceRequest.suite.property.name} - #${serviceRequest.suite.number || serviceRequest.commonArea.name}.`;
      } else if(activeStatus === 'Scheduled') {
        statusMessage = statusMessage + `${moment(serviceRequest.appointment.scheduledAt).format('dddd MMMM DD, YYYY hh:mmA')}.`
      } else {
        statusMessage = statusMessage
      }
    } else {
      statusMessage = ""
    }
    return (
      <>
        <Toast
          color={activeStatus === "On Hold" ? "yellow" : "teal"}
          message={statusMessage}
          actions={(
            <>
            {activeStatus !== 'Declined' &&
              <Button
                size="tiny"
                label="Decline"
                outline="teal"
                onClick={() => window.confirm(`Are you sure you want to change the status to declined?`) && handleStatusChange({name: "Declined"}, serviceRequest.id)}
              />}
                
                <select
                 value={activeStatus}
                 className="button button--tiny button--outline-teal"
                 onChange={e => window.confirm(`${e.target.value === "Archive"?"Are you sure you want to Archive this service request":"Are you sure you want to change the status to " +  e.target.value.toLowerCase()} ?`) && handleStatusChange({name: e.target.value}, serviceRequest.id)}
                >
                {statuses.map((stat, i) => (
                <option value={stat.value}>{stat.label}</option>
                ))}
                </select>
            </>
          )}
        />
      </>
    )
}

export default ServiceRequestToast;
